const Tab = (props: {
    isSelected: boolean
    onClick: () => void
    children: React.ReactNode
}) => {
    const {isSelected, onClick, children} = props
    return (
        <div
            onClick={onClick}
            className={`cursor-pointer py-2 text-center ${
                isSelected ? 'rounded-full bg-yellow-10 text-white' : ''
            } text-xs font-bold`}
        >
            {children}
        </div>
    )
}

export default Tab
